import React from "react";
import { createUseStyles, useTheme } from "react-jss";
import { Link } from "gatsby";

import { PageInner } from "components/PageContainers";
import { GAEventLink } from "components/Tracking/GAEventActions";
import github from 'images/github-logo.svg';
import twitter from 'images/twitter-logo.svg';
import linkedin from 'images/linkedin-logo.svg';

const useStyles = createUseStyles(theme => ({
  pageInner: {
    marginTop: '7.5rem',
    '& *': {
      fontSize: '1.4rem'
    }
  },
  topLinks: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingBottom: '3rem',
    [`@media (min-width: ${theme.breakpoints.medium.min})`]: {
      justifyContent: 'space-between'
    }
  },
  topLinksSection: {
    padding: '0 4rem 2rem 0'
  },
  linksHeader: {
    fontSize: '1.4rem',
    marginBottom: '2rem'
  },
  footerList: {
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    margin: 0,
    padding: 0
  },
  topLinksList: {
    flexDirection: 'column',
  },
  footerSectionItem: {
    '& + &': {
      marginTop: '2rem'
    }
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    color: theme.colors.gray.main
  },
  linkLogo: {
    width: '1.9rem',
    marginRight: '1rem'
  },
  address: {
    lineHeight: '1.5'
  },
  copyright: {
    padding: '1rem 0 2rem',
    borderTop: `1px solid ${theme.colors.gray.light}`,
    [`@media (min-width: ${theme.breakpoints.large.min})`]: {
      padding: '2rem 0 3rem',
    },
    [`@media (max-width: ${theme.breakpoints.medium.max})`]: {
      opacity: '50%'
    }
  },
  footerBottomLinksM: {
    paddingBottom: '1rem',
    '& ul': {
      flexDirection: 'column'
    },
    '& li': {
      marginBottom: '1rem'
    },
    '& a': {
      opacity: '50%'
    },
    [`@media (min-width: ${theme.breakpoints.large.min})`]: {
      display: 'none'
    }
  },
  footerBottomLinks: {
    display: 'none',
    marginTop: '1rem',
    '& li': {
      paddingRight: '1rem',
      '& + li': {
        borderLeft: `1px solid ${theme.colors.gray.main}`,
        paddingLeft: '1rem'
      }
    },
    [`@media (min-width: ${theme.breakpoints.large.min})`]: {
      display: 'block'
    },
  }
}));

const Footer = () => {
  const theme = useTheme();
  const styles = useStyles({ theme });
  const bottomLinks = (
    <ul className={`${styles.footerList}`}>
      <li><a className={styles.link} href="https://docs.edgeimpulse.com/page/privacy-policy">Privacy Policy</a></li>
      <li><a className={styles.link} href="https://docs.edgeimpulse.com/page/terms-of-service">Terms of Service</a></li>
      <li><a className={styles.link} href="https://docs.edgeimpulse.com/page/responsible-ai-license">Responsible AI License</a></li>
    </ul>
  );

  return (

<div class="footer wf-section">
<div class="container-1280px">
   <div class="footer-content">
      <div class="w-layout-grid grid-10" style={{gridTemplateColumns: "200px 200px 200px 200px 200px 200px"}}>
         <div id="w-node-a05911f6-c4aa-efc0-666c-4d89ff482833-ff48282f" class="footer-logo"><img src="https://assets-global.website-files.com/618cdeef45d18e4ef2fd85f3/618e33d89badebdfe7c5897a_Logo%20(2).svg" loading="lazy" alt=""/></div>
         <div id="w-node-a05911f6-c4aa-efc0-666c-4d89ff482835-ff48282f" class="footer-menu">
            <p class="paragraph-m footer-header">Edge Impulse</p>
            <a href="/" aria-current="page" class="footer-link w--current">Home</a><a href="/product" class="footer-link">Product</a><a href="https://www.edgeimpulse.com/blog" class="footer-link">Blog</a><a href="/careers" class="footer-link">Careers</a><a href="/about" class="footer-link">About </a>
         </div>
         <div id="w-node-a05911f6-c4aa-efc0-666c-4d89ff482842-ff48282f" class="footer-menu">
            <p class="paragraph-m footer-header">Studio</p>
            <a href="https://studio.edgeimpulse.com/login" class="footer-link">Login</a><a href="https://docs.edgeimpulse.com/docs" class="footer-link">Documentation</a>
         </div>
         <div id="w-node-a05911f6-c4aa-efc0-666c-4d89ff482849-ff48282f" class="footer-menu">
            <p class="paragraph-m footer-header">Community</p>
            <a href="https://forum.edgeimpulse.com/" class="footer-link">Forum</a>
         </div>
         <div id="w-node-a05911f6-c4aa-efc0-666c-4d89ff482855-ff48282f" class="footer-menu">
            <p class="paragraph-m footer-header">Contact</p>
            <a href="/contact" class="footer-link">Contact us</a>
            <div class="footer-contact-area">
               <div class="paragraph-s grey">Edge Impulse <br/>3031 Tisch Way <br/>110 Plaza West<br/>San Jose, CA 95128 <br/>USA</div>
            </div>
         </div>
      </div>
   </div>
   <div class="subfooter">
      <div class="sub-links">
         <div class="footer-subtext">© 2022 EdgeImpulse Inc. All rights reserved &nbsp; | &nbsp; <a href="https://docs.edgeimpulse.com/page/privacy-policy" target="_blank" class="footer-sublink">Privacy Policy</a> &nbsp; | &nbsp; <a href="https://docs.edgeimpulse.com/page/terms-of-service" target="_blank" class="footer-sublink">Terms of Service</a> &nbsp; | &nbsp; <a href="https://docs.edgeimpulse.com/page/responsible-ai-license" target="_blank" class="footer-sublink">Responsible AI License</a></div>
      </div>
   </div>
</div>
</div>
  )
};

export default Footer;
